
<sm-title-bar pageTitle="{{ 'employee_invitation_details.title' | translate }}" [backWithParams]="true"></sm-title-bar>

<!-- <div class="merchant_detail_sec" *ngIf="!loader">
  <div class="mrt_offe">
    <div class="row">
     
      <div class="col-sm-12">
        <div class="drt_head">
        </div>
        <div class="list_user">
          <a href="javascript:void(0)" class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">
                <div>
                  <span class="name_cont">{{employeeData[0].toName}}</span>
                  <button
                    *ngIf="employeeData[0].requestStatus != 3"
                    mat-icon-button
                    [matMenuTriggerFor]="menu"
                    class="profile_button"
                    class="share"
                  >
                    <mat-icon class="material-icons-outlined"
                      >more_vert</mat-icon
                    >
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="cancelOffer()" [disabled]="employeeData[0].requestStatus == 2">
                      <mat-icon class="material-icons-outlined"
                        >delete</mat-icon
                      >
                      <span class="menu_text">{{ 'employee_invitation_details.cancel' | translate }}</span>
                    </button>
                  </mat-menu>
                </div>

              </div>

            </div>
            <div class="card_body cbody">
              <div class="row"> 
                <div class="col-md-6">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat"> call </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ 'employee_invitation_details.phone' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                        {{employeeData[0].toPhone}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat">
                          segment
                        </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ 'employee_invitation_details.joining_salary' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                       Rs.{{employeeData[0].joiningSalary}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat">
                          calendar_month
                        </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ 'employee_invitation_details.invited_date' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                       
                       {{employeeData[0].creationDate | date}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" >
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat">
                          note
                        </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ 'employee_invitation_details.note' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail">
                       
                       {{(employeeData[0].note && employeeData[0].note != 'null') ? employeeData[0].note: 'No notes added'}} 
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" >
                  <div class="sub_one sub_margin">
                    <div class="sub_one_cont">
                      <div>
                        <span class="material-icons icon_mat">
                          segment
                        </span>
                      </div>
                      <div class="entity_detail make_text_grey">
                        {{ 'employee_invitation_details.status' | translate }}
                      </div>
                    </div>
                    <div class="sub_one_cont main_text">
                      <div class="entity_detail" *ngIf="employeeData[0].requestStatus == 1">
                       
                        {{ 'employee_invitation_details.pending' | translate }}
                      </div>
                      <div class="entity_detail" *ngIf="employeeData[0].requestStatus == 2">
                       
                        {{ 'employee_invitation_details.accepted' | translate }}
                      </div>
                      <div class="entity_detail" *ngIf="employeeData[0].requestStatus == 3">
                       
                       {{ 'employee_invitation_details.declined' | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
          </a>
        </div>
      </div>
    </div>

  </div>
</div> -->



<div class="help_accd">
  <div class="op_section" style="margin-bottom: 50px;">
    <div class="merchant_detail_sec" *ngIf="!loader">
      <div class="mrt_offe">
            <div class="list_user">
                  <mat-card>
                   <div class="flexbn_sectin">
                    <div class="card_header">
                      <div class="adm_set">
                        <div style="text-align: left;">
                          <div class="card-icon">
                            <img *ngIf="employeeData[0].entityInfo.revenue_model == 1" [src]="employeeData[0].entityInfo.default_thumb_image" onerror="this.src='../../../../assets/images/entity_placeholder.png'" alt="">
                            <img *ngIf="employeeData[0].entityInfo.revenue_model == 2" [src]="employeeData[0].entityInfo.default_thumb_image" onerror="this.src='../../../../assets/images/fitness-placeholder.png'" alt="">
                          </div>
                        </div>
                      </div>
                      <!--  -->
                      <div *ngIf="employeeData[0].status == 1"  style="    display: flex
                      ; margin-top: 40px;
                          gap: 10px;
                          justify-content: center;
                          align-items: center;">

                          <div class="employee_btn errorx">
                              <button style="width: 150px;
                              background-color: #ffffff;
                              color: #444444;
    border: 1px solid #9a9a9a;
    border-radius: 8px;
    height: 42px;" mat-flat-button color="primary" (click)="setAcceptanceStatus(2,employeeData[0])"> <mat-icon>cancel</mat-icon> Deny</button>
                            </div>
                          <div class="employee_btn success">
                              <button style="width: 150px;
                              background-color: #ffffff;
                              color: #26C00D;
                              border: 1px solid #26C00D;
                              border-radius: 8px;
                              height: 42px;" mat-flat-button (click)="setAcceptanceStatus(1,employeeData[0])"> <mat-icon>check_circle</mat-icon> Confirm</button>
                            </div>
                    </div>
                    </div>
                 <div class="card_body cbody">
               <!-- Button to trigger the options menu -->
                <div class="emop_section">
                  <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="profile_button" *ngIf="employeeData[0].requestStatus != 3">
                    <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                  </button> -->

                  <!-- Option Menu -->
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item [disabled]="employeeData[0].requestStatus == 2"  (click)="cancelOffer()" >
                      <mat-icon class="material-icons-outlined">cancel</mat-icon>
                      <span>{{ 'employee_invitation_details.cancel' | translate }}</span>
                    </button>
                  </mat-menu>
                </div>
                  <h3 class="name_cont">{{employeeData[0].entityInfo.name}}</h3>
               
                  <div class="hjl_sectin">
              </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat"> call </span>
                          </div>

                          <div class="entity_detail make_text_grey">
                           Phone
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 30px;">
                            {{employeeData[0].entityInfo.country_code}} {{employeeData[0].entityInfo.phone}} 
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat"> payments </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                            Joining salary 
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 30px;">
                            {{employeeData[0].entityInfo.currency_symbol}}{{employeeData[0].joiningSalary}} 
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat">
                              calendar_month
                            </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                            Joining Date 
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 30px;">
                            {{employeeData[0].joiningDate | date}} 
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat">
                              description
                            </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                            Note 
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 30px;">
                            {{(employeeData[0].note && employeeData[0].note != 'null') ? employeeData[0].note: '---'}} 
                          </div>
                        </div>
                      </div>
                    </div>
                     <div class="col-md-12">
                      <div class="sub_one sub_margin">
                        <div class="sub_one_cont">
                          <div>
                            <span class="material-icons icon_mat">
                              receipt_long
                            </span>
                          </div>
                          <div class="entity_detail make_text_grey">
                            Status 
                          </div>
                        </div>
                        <div class="sub_one_cont main_text">
                          <div class="entity_detail" style="margin-left: 32px;" *ngIf="employeeData[0].status == 1">
                            New Invitation 
                          </div>
                          <div class="entity_detail" style="margin-left: 32px;" *ngIf="employeeData[0].status == 2">
                            Accepted 
                          </div>
                          <div class="entity_detail" style="margin-left: 32px;" *ngIf="employeeData[0].status == 3">
                            Declined 
                          </div>
                          <div class="entity_detail" style="margin-left: 32px;" *ngIf="employeeData[0].status == 4">
                            Cancelled by business owner 
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </mat-card>
      </div>
    </div>
</div>
  </div>
</div>
